import { useTranslations } from "@fenetech/translations";
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import React from 'react';
import { useCADActions, useCADState } from "../../Context/CADContext";
import { EdgeAdjustmentsEnum } from "../../enums";
import useCADAvailableOperations from "../../hooks/useCADAvailableOperations";
import GlassLayerSelection from "../GlassLayerSelection/GlassLayerSelection";
import { CADHelpers } from "../../CADHelpers";

interface ICADOperationTabsMobileProps {
    currentTab: string;
}

const CADOperationTabsMobile: React.FC<ICADOperationTabsMobileProps> = (props: ICADOperationTabsMobileProps) => {

    const cadState = useCADState();
    const cadActions = useCADActions();
    const tm = useTranslations();

    const handleTabChange = (event: SelectChangeEvent<string>) => {
        cadActions.setCurrentTab(event.target.value);
        cadActions.clearUIState();
    }

    const availableOperationTypes = useCADAvailableOperations(cadState.currentLayer);

    const enabledTools = cadState.model?.layer.edgeAdjustmentTools ?? EdgeAdjustmentsEnum.None;

    return <>
        <FormControl fullWidth sx={{ mb: 1, mr: 1 }}>
            <GlassLayerSelection/>
        </FormControl>
        <FormControl fullWidth >
            <InputLabel>
                {
                    tm.Get("Operation Type")
                }
            </InputLabel>

            <Select
                label={tm.Get("Operation Type")}         
                value={props.currentTab}
                onChange={handleTabChange}
                variant="outlined"
                fullWidth
            >

                {availableOperationTypes.map((opType, index) => {
                    return <MenuItem key={`TBL_${index}_${opType.toString()}`} value={opType.toString()} >
                        <Typography >{tm.Get(CADHelpers.OperationTypeDescriptionFromEnum(opType))}</Typography>
                    </MenuItem>
                })}

                {enabledTools > 0 &&
                    <MenuItem key={`TBL_-1_EdgeAdjustments`} value="EdgeAdjustments"  >
                        <Typography>{tm.Get("Edge Adjustments")}</Typography>
                    </MenuItem>
                }

            </Select>

        </FormControl>
    </>

}

export default CADOperationTabsMobile;